$(document).ready(function () {
  $(".mak-scrol-logo").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    prevArrow:
      "<img class='prev slick-prev mak-previous' src='https://cdn.shopify.com/s/files/1/0827/4208/3930/files/chevron-left-solid.svg?v=1740338671'>",
    nextArrow:
      "<img class='next slick-next mak-nextt' src='https://cdn.shopify.com/s/files/1/0827/4208/3930/files/chevron-right-solid_1.svg?v=1740338672'>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
   if (window.matchMedia("(min-width: 769px)").matches) {
  $(".catagory-scroll").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1000,
    prevArrow:
      "<img class='prev slick-prev mak-previous' src='https://cdn.shopify.com/s/files/1/0827/4208/3930/files/chevron-left-solid.svg?v=1740338671'>",
    nextArrow:
      "<img class='next slick-next mak-nextt' src='https://cdn.shopify.com/s/files/1/0827/4208/3930/files/chevron-right-solid_1.svg?v=1740338672'>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
   }
  $(".mak-menu-scroll").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 9,
    slidesToScroll: 4,
    autoplay: false,
    autoplaySpeed: 3000,
    prevArrow:
      "<img class='prev slick-prev mak-previous' src='https://cdn.shopify.com/s/files/1/0827/4208/3930/files/chevron-left-solid.svg?v=1740338671'>",
    nextArrow:
      "<img class='next slick-next mak-nextt' src='https://cdn.shopify.com/s/files/1/0827/4208/3930/files/chevron-right-solid_1.svg?v=1740338672'>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
  // DESKTOP
  $(document).ready(function () {
    $(".mak_menu-item").hover(
      function () {
        var targetId = $(this).attr("data-target");

        // Hide all mega menus with smooth effect
        $(".mak_mega-menu").removeClass("active");

        // Show the corresponding mega menu
        $("#" + targetId).addClass("active");
      },
      function () {
        // Optional: Hide menu when mouse leaves
        var targetId = $(this).attr("data-target");
        $("#" + targetId).removeClass("active");
      }
    );

    // Keep menu open when hovered
    $(".mak_mega-menu").hover(
      function () {
        $(this).addClass("active");
      },
      function () {
        $(this).removeClass("active");
      }
    );
  });
  // MOBILE
 
  if (window.matchMedia("(max-width: 990px)").matches) {
    $(".mak_reviews-grid").slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 2000,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: "25px",
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      prevArrow:
        "<img class='prev slick-prev mak-previous' src='https://cdn.shopify.com/s/files/1/0875/6710/6346/files/chevron-left-solid.svg?v=1719714101'>",
      nextArrow:
        "<img class='next slick-next mak-nextt' src='https://cdn.shopify.com/s/files/1/0875/6710/6346/files/chevron-right-solid.svg?v=1719714084'>",
    });
  }



  $(document).ready(function () {
    $("[data-product-id]").each(function () {
      let product = $(this);
      let badges = product.find(".sn-badge");
      let descs = product.find(".sn-badge-desc");

      badges.on("click", function () {
        let index = badges.index(this);
        descs.eq(index).show();
        badges.hide();
      });

      descs.on("click", function () {
        $(this).hide();
        badges.show();
      });

      // Initially hide all descriptions
      descs.hide();
    });
  });
});
$(document).ready(function ($) {
  $(".aa").css("opacity", "1");
  $(".sliderSingle").slick({
    arrows: false,
    autoplaySpeed: 2000,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  });
});



$(document).ready(function () {
  $(".mak_menu-item-mob").each(function () {
    let $menuItem = $(this);
    let $megaMenu = $menuItem.find(".mak_mega-main-mob2");
    let $link = $menuItem.find(".menu-drawer__menu-item");
    let $backBtn = $menuItem.find(".mar-clik-back");

    if ($megaMenu.length) {
      // Open menu
      $link.on("click", function (event) {
        event.preventDefault();
        $(".mak_menu-item-mob").not($menuItem).removeClass("active");
        $menuItem.addClass("active");
      });

      // Close menu on back button
      $backBtn.on("click", function () {
        $menuItem.removeClass("active");
      });
    }
  });
});